export const CONFIRM_DIALOG_OPTIONS = {
  width: '600px',
  maxWidth: '95vw',
  panelClass: 'no-radius-dialog',
};
